import useUser from '@vl-core/hooks/useUser';

export function useIsClientAdmin() {
  const user = useUser();
  const userRole = user?.user_type_code;

  return userRole === 'CLIENTADMIN';
}

export default useIsClientAdmin;
